import DatasetAttributeGroup from '../dataset_attribute_group';
import FilterAttribute from './filter_attribute';
import {ATTRIBUTES} from "../../../../../../utils/query_utils";

export default class FiltersGroup extends DatasetAttributeGroup {
    placeholder = 'Order Date within last 7 days';
    type = ATTRIBUTES.FILTER;
    AttributeComponent = FilterAttribute;
}
